import { createContext, useContext } from "react";

export const LandContext = createContext();

export function useLand() {
  return useContext(LandContext);
}
